import { i18n, useTranslation, type SupportedLanguage } from '@eon/i18n';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@eon/ui';
import { Globe } from 'lucide-react';

const LANGS: { code: SupportedLanguage; flag: string; label: string }[] = [
  { code: 'tr', flag: '🇹🇷', label: 'Türkçe' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
];

export function LanguageSwitcher() {
  const { i18n: i18nInstance } = useTranslation();
  const current = LANGS.find((l) => l.code === i18nInstance.language) ?? LANGS[0];

  function changeLang(code: SupportedLanguage) {
    void i18n.changeLanguage(code);
    localStorage.setItem('eon.lang', code);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 px-2.5 text-sm font-medium">
          <Globe className="h-4 w-4 text-muted-foreground" />
          <span className="hidden sm:inline">{current?.flag}</span>
          <span className="hidden md:inline text-muted-foreground">{current?.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[130px]">
        {LANGS.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onSelect={() => changeLang(lang.code)}
            className={lang.code === i18nInstance.language ? 'text-primary font-medium' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
